import React from 'react';

const Blog = () => {
    return (
        <div>
            <h2>Welcome to Rapid Rides Blog. It will comming Very Soon.........</h2>
        </div>
    );
};

export default Blog;